import { render, staticRenderFns } from "./SignHeroSetPasswordField.vue?vue&type=template&id=81fd6d1c&scoped=true"
import script from "./SignHeroSetPasswordField.vue?vue&type=script&lang=js"
export * from "./SignHeroSetPasswordField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fd6d1c",
  null
  
)

export default component.exports